import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=7af9f475&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7af9f475"]])

export default __exports__